<template lang="pug">
  .component-backoffice-driver-pending-delete.row.column
    base-list(
      :component="component",
      :dataLoader="dataLoader",
      componentType="pendingDelete"
    )
</template>

<script type="text/babel">

  import BaseList from './BaseList'
  import SelectizeDriver from '../../components/structure/ui/lists/selectize/SelectizeDriver'
  import AccontStatusFilter from '../../components/backoffice/tabbed/AccontStatusFilter'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  export default {
    name: 'DriverPendingDeleteQueue',
    components: {
      AccontStatusFilter,
      SelectizeDriver,
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Driver.vue'),
        headers: [' ', 'Driver ID / Name', 'City', 'Requested date', 'Phone & Mail', ''],
      }
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.drivers.list(page, resultsPerPage).pendingDelete((data) => {
          callback(data)
        })
      },
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-driver-approval
    .activeIcon
      color: #64db6f
</style>



// WEBPACK FOOTER //
// DriverPendingDeleteQueue.vue?79932099